/** @format */

import dynamic from "next/dynamic";
import { Layout } from "../components/common/Layout";
import Spinner from "../components/Spinner/Spinner";

const DynamicCartWrapper = dynamic(() => import("../components/Cart/Cart"), {
  ssr: false,
  loading: () => <Spinner />,
});

function Cart() {
  const meta = {
    title: "Cart | Qalara",
    description:
      "Global wholesale platform for sourcing artisanal & sustainable lifestyle goods - Décor, Rugs ,Carpets, Kitchen, Fashion, Kids, Toys, Cushions, Home linen, vases",
    keywords: "",
  };

  return (
    <Layout meta={meta}>
      <DynamicCartWrapper />
    </Layout>
  );
}
export default Cart;
